import React, { FC } from 'react';
import FindProgramAccordionItem, {
  FindProgramAccordionItemProps,
} from 'evcharging/containers/ev-rebates/FindProgramAccordionItem';

interface FindProgramAccordionProps {
  items: FindProgramAccordionItemProps[];
  nested?: boolean;
}

const FindProgramAccordion: FC<FindProgramAccordionProps> = (props) => {
  const { items, nested } = props;

  return (
    <>
      {items.map((item) => (
        <FindProgramAccordionItem {...item} nested={nested} key={item.title} />
      ))}
    </>
  );
};

export default FindProgramAccordion;
